// @file Surface Trashed view
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSurfaceTrashedViewStore = defineStore('surfaceTrashedView', () => {
  // State
  const isCurrentUserWallBuilder = ref<boolean>(false)
  const redirectUrl = ref<string>('/')

  // Actions
  function initializeState(startingState: { isCurrentUserWallBuilder: boolean; redirectUrl: string }): void {
    isCurrentUserWallBuilder.value = startingState.isCurrentUserWallBuilder
    redirectUrl.value = startingState.redirectUrl
  }

  return {
    // State
    isCurrentUserWallBuilder,
    redirectUrl,
    // Actions
    initializeState,
  }
})
